import { HeaterPowerIssueEvent, HeaterSample } from 'types/models/heater';
import { PowerMeterSample } from 'types/models/power-meter';
import Sample, { ControlPointSample, SampleDate, SampleId } from 'types/models/sample';
import { SamplePointId } from 'types/models/samplePoint';

export type SamplesState = {
  samplePointSamples: Record<SampleId, Sample>;
  controlPointSamples: Record<SampleId, ControlPointSample>;
  powerMeterSamples: Record<SampleDate, PowerMeterSample>;
  heaterSamples: Record<SampleDate, HeaterSample>;
  /**
   * Events that are created by HEATER_POWER_SUPPLY_* triggers.
   *
   * PRAGMATIC DESIGN NOTE:
   * This belongs here for implementation convenience, not semantic correctness.
   * Events are conceptually different from samples (state changes vs. measurements),
   * but creating a separate store module is premature given uncertainty about
   * whether grouping should be by heater/addon/event concept.
   *
   * Future consideration: Move to dedicated module when architecture becomes clearer.
   */
  heaterPowerIssueEvents: HeaterPowerIssueEvent[];
};

export enum SampleInterval {
  HOURLY = 'hourly',
  DAILY = 'daily',
  WEEKLY = 'weekly',
  MONTHLY = 'monthly'
}

export type ConnectedSamplePointIds = { destination?: SamplePointId, source?: SamplePointId };